module.exports = __webpack_public_path__ + "static/img/8b.f1556a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/8b.jpg
// module id = SdZD
// module chunks = 0